// import { encrypt } from '../../../utils/cryptoHelper';

export function prepareSearchUrl(
    query: string,
    originalUrl: string,
    encryptionDetails?: EncryptionDetailsType,
): string {
    const shouldKeepOriginalUrl = (url): boolean => {
        return url && url.match(/^(http|https):\/\/www\.youtube\.com/);
    };
    // const { encryptionSetting, publicKey, publicKeyVersion } =
    // 	encryptionDetails;

    if (shouldKeepOriginalUrl(originalUrl)) {
        return originalUrl;
    }
    if (query && query.match(/^(http|https):\/\/[^ "]+$/)) {
        return query;
    }
    // if (encryptionSetting && publicKey) {
    // 	const encryptedQuery = encrypt(
    // 		{ q: query, rh: 1, wb: 1, wbvers: 'v2' },
    // 		publicKey,
    // 		publicKeyVersion,
    // 		'Wikibox',
    // 	);
    // 	return `/search?encv=${encryptedQuery.encv}&encq=${encodeURIComponent(
    // 		encryptedQuery.encq,
    // 	)}`;
    // }
    return `/search?q=${encodeURIComponent(query)}`;
}
